export const firebaseConfig = {
  apiKey: "AIzaSyAwOaaIRMfh6montuyDxRQKxn-1qwwKKlc",
  authDomain: "pao-todo.firebaseapp.com",
  databaseURL: "https://pao-todo.firebaseio.com",
  projectId: "pao-todo",
  storageBucket: "pao-todo.appspot.com",
  messagingSenderId: "469774565491"
};



// WEBPACK FOOTER //
// ./src/firebase/config.js